import qs from 'qs'
import Vue from 'vue'

export const state = () => {
  return {
    user: {
      first_name: '',
      last_name: '',
      email: '',
      emailRepeat: ''
    }
  }
}

export const mutations = {
  SET_USER_FIELD (state, data) {
    Vue.set(state.user, data.field, data.value)
  },
  SET_USER (state, data) {
    const { first_name, last_name, email } = data
    state.user = {
      first_name,
      last_name,
      email,
      emailRepeat: email
    }
  }
}

export const getters = {}

export const actions = {
  async login ({ dispatch }, formData) {
    await this.$axiosCheckout.post('/login', qs.stringify(formData))
    const user = await dispatch('getUser')
    return user
  },
  async getUser ({ commit }) {
    const { data } = await this.$axiosCheckout.get('/user')
    if (data) commit('SET_USER', data)
    return data
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}